import { jsx as _jsx } from "react/jsx-runtime";
import { SimMainDialog } from './main-dialog';
import { SimsList } from './sim-list';
import { SimOrderCompare } from './order-sim';
import { RegisterSimFormRouter } from 'console/sim/register-sim-dialog/register-sim-form';
import { ForeignSim } from 'console/sim/foreign';
import { BilledSimDialogContent } from 'console/sim/billed-sim';
import { BilledSimPayFormRouter } from 'console/sim/billed-sim/pay-form/pay-form';
import { BilledSimChangeTariff } from 'console/sim/billed-sim/change-tariff';
import { BilledSimChangeTariffConfirmation } from 'console/sim/billed-sim/change-tariff/confirmation';
import { SimOrder } from 'console/sim/order-sim/order';
export const simRoutes = [
    {
        path: '/sim',
        element: _jsx(SimMainDialog, {}),
        children: [
            {
                path: 'list',
                element: _jsx(SimsList, {}),
            },
            {
                path: 'billed/:sim_id/:operator',
                element: _jsx(BilledSimDialogContent, {}),
            },
            {
                path: 'billed/:sim_id/:operator/pay',
                element: _jsx(BilledSimPayFormRouter, {}),
            },
            {
                path: 'billed/:sim_id/:operator/change_tariff',
                element: _jsx(BilledSimChangeTariff, {}),
            },
            {
                path: 'billed/:sim_id/:operator/change_tariff/:tariff_id',
                element: _jsx(BilledSimChangeTariffConfirmation, {}),
            },
            {
                path: 'foreign/:msisdn',
                element: _jsx(ForeignSim, {}),
            },
            {
                path: 'add',
                element: _jsx(RegisterSimFormRouter, {}),
            },
            {
                path: 'order',
                element: _jsx(SimOrderCompare, {}),
            },
            {
                path: 'order/:tariff_id',
                element: _jsx(SimOrder, {}),
            },
        ],
    },
];
